import { call, delay, put } from 'redux-saga/effects'

import { push } from 'connected-react-router'
import { PayloadAction } from '@reduxjs/toolkit'
import { getOpenApiInstance, Response } from '../../api/api'
import { ScoringType, Saga } from '../../types'
import { scoringActions, analyticsActions } from '../../redux'

import { CLIENT_SCORING_ERRORS } from '../../constants/errors'

import Routes from '../../constants/routes'

import { POLLING_DELAY_IN_MS } from '../../constants'

export function* startScoring({ payload }: PayloadAction<ScoringType>): Saga {
  const { error, apiError } = payload
  const response: any = yield call(getOpenApiInstance().startClientScoring)

  const statusCode: string = response.data?.status || ''

  if (response.responseStatus === Response.ok) {
    switch (statusCode) {
      case 'OK':
        yield put(scoringActions.startScoringLoop(payload))
        break

      case 'BRANCH':
        yield put(push(Routes.KO_ONLINE))
        break
      case 'NOK':
        const text: string = response.data?.text || ''
        error(CLIENT_SCORING_ERRORS.NOK, text)
        break

      default:
        apiError(response.responseStatus, false)
    }
  } else {
    apiError(response.responseStatus, false)
  }
}

let startTimestamp: Date | undefined

export function* startScoringLoop({ payload }: PayloadAction<ScoringType>): Saga {
  if (!startTimestamp) {
    startTimestamp = new Date()
  }
  const { success, error, apiError, updateText } = payload
  const response: any = yield call(getOpenApiInstance().getClientScoringStatus)

  if (response.responseStatus === Response.ok) {
    const statusCode: any = response.data?.status || ''
    const text: string = response.data?.text || ''

    switch (statusCode) {
      case 'OK':
        yield put(analyticsActions.setCantSend(false))
        success()
        break

      case 'OK_BRANCH':
        yield put(push(Routes.OK_BRANCH))
        break

      case 'NOK':
        error(CLIENT_SCORING_ERRORS.NOK, text)
        break

      case 'IN_APPROVAL':
        text && updateText(text)

        yield delay(POLLING_DELAY_IN_MS)
        yield put(scoringActions.startScoringLoop(payload))
        break

      default:
        break
    }
  } else {
    apiError(response.responseStatus, true)
  }
}
